import React from 'react';

import { Tooltip } from '@/components/Tooltip';

function WindowsIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M0 2.3l6.5-.9v6.3H0V2.3zm7.3-1l8.7-1.3v7.6H7.3V1.3zM16 8.4v7.6l-8.7-1.2V8.4H16zM6.5 14.7L0 13.8V8.4h6.5v6.3z" />
    </svg>
  );
}

function LinuxIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.268-.45.6-.663.839-.199.199-.485.267-.797.4-.313.136-.658.269-.864.68-.09.189-.136.394-.132.602 0 .199.027.4.055.536.058.399.116.728.04.97-.249.68-.28 1.145-.106 1.484.174.334.535.47.94.601.81.2 1.91.135 2.774.6.926.466 1.866.67 2.616.47.526-.116.97-.464 1.208-.946.587-.003 1.23-.269 2.26-.334.699-.058 1.574.267 2.577.2.025.134.063.198.114.333l.003.003c.391.778 1.113 1.132 1.884 1.071.771-.06 1.592-.536 2.257-1.306.631-.765 1.683-1.084 2.378-1.503.348-.199.629-.469.649-.853.023-.4-.2-.811-.714-1.376v-.097l-.003-.003c-.17-.2-.25-.535-.338-.926-.085-.401-.182-.786-.492-1.046h-.003c-.059-.054-.123-.067-.188-.135a.357.357 0 00-.19-.064c.431-1.278.264-2.55-.173-3.694-.533-1.41-1.465-2.638-2.175-3.483-.796-1.005-1.576-1.957-1.56-3.368.026-2.152.236-6.133-3.544-6.139z" />
    </svg>
  );
}

function AppleIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M12.2 5.4c-.1.1-1.6.9-1.6 2.8 0 2.2 1.9 3 2 3-.1.1-.3 1-.9 2.1-.6.9-1.2 1.8-2.1 1.8s-1.2-.5-2.2-.5c-1.1 0-1.4.5-2.3.5s-1.4-.8-2.1-1.9C2 11.7 1.4 9.7 1.4 7.8c0-3 1.9-4.6 3.8-4.6.9 0 1.7.6 2.3.6.5 0 1.4-.7 2.5-.7.4 0 1.8.1 2.2 1.3zM10.1 2c.4-.5.7-1.2.7-1.9 0-.1 0-.2-.1-.1-.6 0-1.4.4-1.8 1-.4.4-.8 1.1-.8 1.9 0 .1 0 .2.1.1.6-.1 1.3-.5 1.9-1z" />
    </svg>
  );
}

export function getOsIcon(os?: string): React.ReactNode | null {
  if (!os) return null;

  const osLower = os.toLowerCase();

  let icon: React.ReactNode;
  if (osLower.includes('windows')) {
    icon = (
      <WindowsIcon className="text-chariot-text-secondary size-4 shrink-0" />
    );
  } else if (osLower.includes('linux')) {
    icon = (
      <LinuxIcon className="text-chariot-text-secondary size-4 shrink-0" />
    );
  } else if (osLower.includes('darwin') || osLower.includes('macos')) {
    icon = (
      <AppleIcon className="text-chariot-text-secondary size-4 shrink-0" />
    );
  } else {
    return null;
  }

  return (
    <Tooltip title={os} placement="top">
      {icon}
    </Tooltip>
  );
}
